module.exports = __webpack_public_path__ + "static/img/vehicle_violation_account_guide_2.2fb17d0.png";